import { cookie } from '@/utils/cookie'

export async function initPushSw () {
  if (!('serviceWorker' in navigator)) {
    // Service worker isn't supported on this browser
    return
  }

  if (!('PushManager' in window)) {
    // Push isn't supported on this browser
    return
  }
  try {
    // Attempt to fetch the service worker script to check if it exists
    const response = await fetch('/sw.js', { method: 'HEAD' })
    if (response.ok) {
      // Register the service worker only if the script exists
      await navigator.serviceWorker.register('/sw.js')
      console.log('Service Worker installed!')
      initPush()
    } else {
      console.warn('Service Worker script not found. Skipping registration.')
    }
  } catch (error) {
    console.warn('Error fetching Service Worker script:', error)
  }
}

export function initPush () {
  if (!navigator.serviceWorker.ready) {
    return
  }

  new Promise(function (resolve, reject) {
    const permissionResult = Notification.requestPermission(function (result) {
      resolve(result)
    })

    if (permissionResult) {
      permissionResult.then(resolve, reject)
    }
  }).then(permissionResult => {
    if (permissionResult !== 'granted') {
      closeNotificationPrompt()
      throw new Error("We weren't granted permission.")
    } else {
      closeNotificationPrompt()
    }
    subscribeUser()
  })
}

export function subscribeUser () {
  navigator.serviceWorker.ready
    .then(registration => {
      const vapidKey = window.vueAppConfig?.info?.general?.keys?.vapid
      if (!vapidKey) {
        console.error('VAPID key is missing.')
        return
      }

      const subscribeOptions = {
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey)
      }

      return registration.pushManager.subscribe(subscribeOptions)
    })
    .then(pushSubscription => {
      storePushSubscription(pushSubscription)
    })
    .catch(err => {
      console.error('Failed to subscribe the user:', err)
    })
}

function storePushSubscription (pushSubscription) {
  const requestData = {
    data: pushSubscription, // Serialize pushSubscription to JSON
    session_id: cookie(),
    brand_id: window.vueAppConfig.info.id
  }

  fetch(`${window.vueAppConfig.endpoint}/api/v1/push_notifications/subscribe`, {
    method: 'POST',
    body: JSON.stringify(requestData),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(res => res.json())
    .then(res => {
      console.log(res)
    })
    .catch(err => {
      console.error('Failed to store push subscription:', err)
    })
}

function urlBase64ToUint8Array (base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

function closeNotificationPrompt () {
  console.log('Notification prompt closed or permission granted.')
}
